import React from 'react';

import DelegationsPanel from './DelegationsPanel';

// ═══════ VEKÂLETLER — PLATFORM SAYFASI ═══════
//
// Vekâlet Faz J'de YALNIZ "Performans Ayarları → Vekâletler" sekmesinde yaşıyordu ve o
// sekme PM modülüne kilitliydi: ATS kullanan ama Performans'a abone OLMAYAN bir kiracının
// İK'sı teklif onayı vekâletini HİÇBİR yerden kuramazdı. Sayfa, Onay Akışları'nın yanına
// (organizasyon/ayarlar kümesi) platform yüzeyi olarak eklendi — vekâlet, onay akışının
// tamamlayıcısıdır: akış "kim onaylar"ı, vekâlet "o kişi yokken kim onaylar"ı söyler.
//
// Sekme KALDIRILMADI: Performans kullanıcısı kendi kapsamını alıştığı yerde yönetmeye
// devam eder, yalnız o sekme artık kapsamını "performance"a SABİTLER. İki yüzey de AYNI
// bileşeni (DelegationsPanel) sürer; kapı, doğrulama ve denetim izi tek kopyada durur.
//
// Başlık DataTable'ındır (sayfa üstünde ikinci bir başlık şeridi YOK) — Yeni butonu da
// tablonun içindedir.
export default function DelegationsPage() {
  return <DelegationsPanel />;
}
